import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Action } from 'src/common/components/ConfigurableTable/models/configurableTable';
import { ESim } from '../models/esim';
import { ESimAddProfileDialog } from '../Profiles/actions/ESimAddProfileDialog';

export const useESimTableActions = () => {
  const { t } = useTranslation();

  return useMemo(() => {
    const menuActions: Action<ESim>[] = [
      {
        id: 'addProfile',
        label: t('products.eSim.inventory.actions.addESimProfile.title'),
        type: 'dialog',
        Component: ESimAddProfileDialog,
      },
    ];

    return menuActions;
  }, []);
};
